import { UserRole, UserRoleType, RoleType } from '../state/user/types';

const isLinkAllowed = (linkAllowedRoles: UserRoleType[], roles: UserRole[]) => {
  return linkAllowedRoles.some((x) => roles.find((y) => y.name === x));
};

export const showSidebarLink = (
  userRoles: UserRole[],
  linkAllowedRoles: UserRoleType[],
  roleType: RoleType,
  userProjectRoles: UserRole[] | undefined
) => {
  let roles;

  if (roleType === RoleType.ProjectRole && userProjectRoles) {
    const systemRoles = [UserRoleType.SystemAdmin, UserRoleType.ReadAll];
    const userSystemRole = userRoles.filter((x) => systemRoles.includes(x.name));
    roles = [...userSystemRole, ...userProjectRoles];
  }

  return isLinkAllowed(linkAllowedRoles, roles ?? userRoles);
};
